import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
  Router,
  UrlTree
} from '@angular/router';
import { PermisosService } from './permisos.service';
import { ApplicationService } from 'src/app/application/shared/application.service';

/**
 * Rutas públicas que no requieren validación de permisos
 */
const RUTAS_PUBLICAS: string[] = [
  '/auth',
  //'/login',
  //'/user'  // Editar perfil es accesible para todos
];

/**
 * Valida si una URL es una ruta pública
 * @param url URL a validar
 * @returns true si es ruta pública
 */
function esRutaPublica(url: string): boolean {
  return RUTAS_PUBLICAS.some((rutaPublica: string) => {
    // Comparación exacta o si la URL comienza con la ruta pública
    return url === rutaPublica || url.startsWith(rutaPublica + '/');
  });
}

/**
 * Guard funcional que valida permisos de acceso basado en el menú del usuario
 * Previene acceso a rutas copiando URLs sin tener los permisos correspondientes
 * @param route Snapshot de la ruta activada
 * @param state Estado del router
 * @returns true si tiene permisos, de lo contrario redirecciona al dashboard
 * @author Sistema Kobra
 */
export const PermisosGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): boolean | UrlTree => {

  const permisosService: PermisosService = inject(PermisosService);
  const router: Router = inject(Router);
  const appService: ApplicationService = inject(ApplicationService);

  const url: string = state.url.split('?')[0]; // Eliminar query params para comparación

  // Permitir acceso a rutas públicas sin validación
  if (esRutaPublica(url)) {
    return true;
  }

  // Obtener el menú desde localStorage
  const menu: string | null = localStorage.getItem('menu');

  // Si no hay menú cargado, redirigir al dashboard y esperar a que cargue
  if (!menu) {
    console.warn('Menu no cargado aún, redirigiendo al dashboard');
    return router.createUrlTree(['/']);
  }

  // Validar permiso usando el servicio
  const tienePermiso: boolean = permisosService.getPermiso(url);

  if (!tienePermiso) {
    console.warn(`Acceso denegado a la ruta: ${url}`);
    appService.showSnackbar(
      "Aviso",
      "No tienes permisos para acceder a esta sección",
      3000,
      "warning"
    );

    // Redirigir al dashboard
    return router.createUrlTree(['/']);
  }

  return true;
};
